<template>
  <div class="manual-tools02-contents">
    <el-row>
      <el-col>
        <h2>成果データのダウンロード方法（セレス）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>
          【１】<a
            href="https://admin.ad-track.jp/report/"
            target="_blank"
            rel="noopener noreferrer"
            >セレスの管理画面</a
          >にログインし、「レポート」→「成果一覧」の順にクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no03/01.png`" alt="" />
        <h4>【２】「絞り込み」をクリックします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no03/02.png`" alt="" />
        <h4>【３】期間を選択→<span class="red">「メディア端末ID」と「リファラー」にチェックを入れる</span>→「絞り込み」をクリックします。</h4>
        <p class="red">※デフォルトだと当日分が含まれていません。</p>
        <img :src="`${rt}/img/manual/google-cv/no07/no03/03.png`" alt="" />
        <div class="mini-img">

        <img :src="`${rt}/img/manual/google-cv/no07/no03/04.png`" alt="" />
        </div>
        <h4>
          【４】成果が表示されたら、「メディア端末ID」にクリックパラメータ（{{tool.clickIdName}}_xxx）が表示されているか確認します。
        <img :src="`${rt}/img/manual/${tool.codeKebab}/no07/no03/05.png`" alt="" />
        </h4>
        <p class="red">
          ※パラメータが表示されていない場合、パラメータ引継ぎ設定を間違えている可能性があります。
        </p>
        <p>
          「<router-link :to="`/manual/${tool.codeKebab}/06/02`">パラメータ引継ぎタグを設置する</router-link
          >」をご確認ください。
        </p>
        <h4>【５】CSVをダウンロードします。「CSV」をクリックします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no03/06.png`" alt="" />
        <p>
          これで成果CSVのダウンロードは完了です。「<router-link
            :to="`/manual/${tool.codeKebab}/07/14`"
            >ASPの成果データをアドタスカルにインポートする</router-link
          >」に進んでください。
        </p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ManualGoogleCvContents",
  props: {},
  computed: {
    ...mapGetters(["rt","tool"]),
    tools() {
      return this.$store.getters.tools;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
